export function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export function isMp4(src) {
    const regex = /\.(mp4)$/i;
    return regex.test(src);
}
